import { createContext } from "react";

const NotificationContext = createContext(null);

export default NotificationContext;